import React from 'react';
import { useIntl } from 'react-intl';
import { Events, animateScroll } from 'react-scroll';

import { useChangeLayoutVariant } from '@hooks/useArtists';
import { LAYOUT_VARIANT } from '@modules/artists';

import { layoutSwitcherMessages } from './layoutSwitcher.messages';
import { Container, Button } from './layoutSwitcher.styles';

export const LayoutSwitcher = () => {
  const { scrollEvent } = Events;
  const { layoutVariant, changeLayoutVariant } = useChangeLayoutVariant();
  const intl = useIntl();
  const gridCopy = intl.formatMessage(layoutSwitcherMessages.grid);
  const listCopy = intl.formatMessage(layoutSwitcherMessages.list);

  const setLayoutVariant = (layoutVariant: LAYOUT_VARIANT) => () => {
    if (window.pageYOffset > 1) {
      animateScroll.scrollToTop({ duration: 500, smooth: true });
      scrollEvent.register('end', () => changeLayoutVariant({ layoutVariant }));
    } else {
      changeLayoutVariant({ layoutVariant });
    }
  };

  return (
    <Container>
      <Button
        active={layoutVariant === LAYOUT_VARIANT.GRID}
        onClick={setLayoutVariant(LAYOUT_VARIANT.GRID)}
        aria-label={intl.formatMessage(layoutSwitcherMessages.select, { size: gridCopy })}
      >
        {gridCopy}
      </Button>
      <Button
        active={layoutVariant === LAYOUT_VARIANT.LIST}
        onClick={setLayoutVariant(LAYOUT_VARIANT.LIST)}
        aria-label={intl.formatMessage(layoutSwitcherMessages.select, { size: listCopy })}
      >
        {listCopy}
      </Button>
    </Container>
  );
};
